import { Link } from 'react-router-dom'
import { Button } from 'app/components/ui/button'

export function InvalidInvitationScreen() {
  return (
    <div
      data-testid="invalid-invitation-screen"
      className="grid h-dvh place-items-center overflow-y-auto bg-surface-subtle p-4"
    >
      <div className="w-full max-w-md rounded-xl border border-default bg-surface p-8 text-center shadow-sm sm:p-12">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
          <span className="text-3xl">⚠️</span>
        </div>
        <h1 className="mb-3 text-2xl font-semibold text-strong">Invitation No Longer Valid</h1>
        <p className="mb-8 text-base text-subtle">
          This invitation link is no longer active. If you believe this is an error, please contact the person who
          invited you or your workspace administrator.
        </p>
        <Button variant="primary" size="lg" asChild className="w-full">
          <Link to="/">Back to Homepage</Link>
        </Button>
      </div>
    </div>
  )
}
